import { Heading, type HeadingProps } from "@focal/ui-kit";

interface TitleProps extends Omit<HeadingProps, 'children'> {
  text: string;
}

export const Title = ({ 
  text, 
  level = "h3", 
  spacing = "lg", 
  ...props 
}: TitleProps) => {
  return (
    <Heading
      level={level}
      spacing={spacing}
      {...props}
    >
      {text}
    </Heading>
  );
};
